import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { LoadingService } from '../services/loading.service';

@Injectable({ providedIn: 'root' })
export class AuthorizeGuard implements CanActivate {

    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private loadingService: LoadingService
    ) {
    }

    /*canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.loadingService.showLoading(); // Show loading spinner

        return new Promise((resolve) => {
            const isAuthenticated = this.authService.isUserAuthenticated();
            const isAuthorized = this.authService.isUserRoleAuthorized(route.data['roles']);

            this.loadingService.hideLoading(); // Hide loading spinner

            if (isAuthenticated && isAuthorized) {
                resolve(true);
            } else {
                this.authService.logout();
                this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                resolve(false);
            }
        });
    }*/

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        this.loadingService.showLoading(); // Show loading spinner

        const isAuthenticated = this.authService.isUserAuthenticated();
        const isAuthorized = this.authService.isUserRoleAuthorized(route.data['roles']);

        this.loadingService.hideLoading(); // Hide loading spinner

        if (isAuthenticated && isAuthorized) {
            return true;
        }
        this.authService.logout();
        this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
